import { createStyles, Image, rem, Box } from "@mantine/core";
import { Carousel } from "@mantine/carousel";
import { Link } from "react-router-dom";
import PageContainer from "./layout/PageContainer";
import SectionHeader from "./layout/SectionHeader";
import product_info from "../constant/ProductInfo";

const useStyles = createStyles((theme) => ({
  section: {
    position: "relative",
    zIndex: 1,
    borderBottom: `1px solid ${theme.colors.gray[2]}`,
    backgroundColor: theme.white,
    paddingTop: rem(20),
    paddingBottom: rem(16),
    [theme.fn.smallerThan("sm")]: {
      paddingTop: rem(18),
      paddingBottom: rem(14),
    },
  },
  carousel: {
    paddingBottom: rem(4),
    "& .mantine-Carousel-root": {
      height: "auto",
    },
    "& .mantine-Carousel-viewport": {
      overflow: "hidden",
      paddingTop: rem(2),
      paddingBottom: rem(6),
    },
    "& .mantine-Carousel-container": {
      alignItems: "stretch",
    },
    "& .mantine-Carousel-slide": {
      height: "auto",
      display: "flex",
    },
    "& .mantine-Carousel-controls": {
      top: "50%",
      transform: "translateY(-50%)",
    },
  },
  card: {
    display: "block",
    position: "relative",
    width: "100%",
    aspectRatio: "1 / 1",
    textDecoration: "none",
    borderRadius: theme.radius.md,
    border: `1px solid ${theme.colors.gray[2]}`,
    backgroundColor: theme.colors.gray[0],
    overflow: "hidden",
    transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    "&:hover": {
      borderColor: theme.colors.orange[3],
      boxShadow: theme.shadows.sm,
    },
    "& .mantine-Image-root": {
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
    },
    "& .mantine-Image-image": {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      objectPosition: "center",
    },
  },
}));

function ProductSlide({ product, classes }) {
  return (
    <Carousel.Slide>
      <Link
        to={`/${product.url_link}`}
        className={classes.card}
        aria-label={product.title}
      >
        <Image fit="cover" src={product.image[0]} alt="" height="100%" width="100%" loading="lazy" />
      </Link>
    </Carousel.Slide>
  );
}

export default function FeaturedProductSlider() {
  const { classes } = useStyles();

  if (!product_info?.length) {
    return null;
  }

  return (
    <section className={classes.section} aria-labelledby="featured-products-heading">
      <PageContainer>
        <SectionHeader
          id="featured-products-heading"
          title="精選產品"
          size="md"
          align="center"
          showRule
          animate
          compact
        />
        <Box className={classes.carousel}>
          <Carousel
            slideSize="20%"
            slideGap="md"
            align="start"
            loop
            dragFree
            withControls
            controlSize={36}
            breakpoints={[
              { maxWidth: "lg", slideSize: "28%", slideGap: "md" },
              { maxWidth: "md", slideSize: "38%", slideGap: "sm" },
              { maxWidth: "sm", slideSize: "52%", slideGap: "sm" },
            ]}
          >
            {product_info.map((product) => (
              <ProductSlide key={product.url_link} product={product} classes={classes} />
            ))}
          </Carousel>
        </Box>
      </PageContainer>
    </section>
  );
}
